import * as React from "react";
const SvgTriangleDownLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.46 16.406a2 2 0 0 1-2.828.09c-.046-.044-.046-.044-.09-.09l-5.193-5.538A2 2 0 0 1 6.81 7.5h10.383a2 2 0 0 1 1.46 3.368zM12 15.038 17.192 9.5H6.808z", clipRule: "evenodd" }));
export default SvgTriangleDownLine;
